import { IState } from '../types';

const resetSelectedPlace = (state: IState) => {
  state.selectedPlace = null;
};

export default resetSelectedPlace;
